var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabbar" },
    _vm._l(_vm.tabBar, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "tabbar_item",
          on: {
            click: function() {
              return _vm.handleSkip(item)
            }
          }
        },
        [
          _c(
            "div",
            {
              class:
                _vm.active === item.id
                  ? "tabbar_item_text active"
                  : "tabbar_item_text"
            },
            [_vm._v("\n\t\t\t" + _vm._s(item.text) + "\n\t\t")]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d42db40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d42db40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/tabBar.vue
// module id = null
// module chunks = 